
import { readCard } from '../../../utils/readCard';
import { message, Modal } from 'antd';
let add = '';
/**
 * 新中新身份证阅读器接口
 * @param {*} type 阅读器类型（xzx：新中新  hs：华视）
 * @param {*} readPort 阅读器接口端口
 * @param {*} mode 读取模式（手动/自动）
 * @param {*} callback 回调的函数
 */
export const readByXzx = (readPort, mode, callback) => {
    if(!readPort || typeof (readPort) == "undefined"){
        readPort = '8989';
    }
    if(mode == 'auto' ){
        add = readCard((data) => {
            // const { setFieldsValue } = this.props.form;
            // setFieldsValue({ zhlx: 'sfzjh', zh: data.cardno });
            // this.search();
            callback(data.cardno)
        });
        add.start(); //开启
        add.check();
    } else if(mode == 'manual') {
        fetch(`http://127.0.0.1:${readPort}/api/ReadMsg`).then(response => response.json())
        .then((data) => {
            if (data) {
                if (data.retmsg == "读居民身份证操作失败") {
                    message.warn('没有找到身份证，请放置身份证！');
                } else {
                    callback(data.cardno);
                }
            } else {
                message.warn('没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确');
            }
        }).catch(e => Modal.error({ title: '错误信息', content: '没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确' }))
    }
  }


// WEBPACK FOOTER //
// ./components/yxxc/readCard/readByXzx.js